// Funzioni varie...

import {FPNetDate} from "@commons/types";
import {DateTime, Interval} from "luxon";

export function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

//checks if is object, null val returns false
function isObject(val: object): boolean {
    if (val === null) {
        return false;
    }
    return ((typeof val === 'function') || (typeof val === 'object'));
}


interface IObject {
    [propName: string]: any;
}

/**
 * Rimuove la classe java inniettato nel nome delle proprietà dei files json generati dal backend di FPNet
 * N.B. occorre gestire gli array!!!
 * @param data
 * @param convertType
 */
export function cleanPropsName(data: object, convertType: boolean = false): object {
    const newObj: IObject = {};
    const isArray = (arr: any) => Array.isArray(arr);
    if (isObject(data))
        Object.entries(data).forEach(([key, value], index) => {
            const pos = key.indexOf(':')
            let type: string | null = null;
            if (pos >= 0) {
                type = key.substring(pos + 1);
                key = key.substring(0, pos);
            }
            if (convertType) {
                if (type === 'util.TimeStamp') { //'YYYY-MM-DDTHH:mm:ss'
                    newObj[key] = DateTime.fromISO(value).toJSDate();

                } else if (type === 'java.util.Date') { // 'YYYY-MM-DD'
                    newObj[key] = DateTime.fromISO(value).toJSDate();
                } else {
                    newObj[key] = isObject(value) ? cleanPropsName(value) : value;
                }
            } else {
                if (isArray(value)) {
                    newObj[key] = [];
                    value.forEach((element: any) => {
                        newObj[key].push(isObject(element) ? cleanPropsName(element) : element);
                    });
                } else
                    newObj[key] = isObject(value) ? cleanPropsName(value) : value;
            }
            //console.log(key, value, index);
        });
    return newObj;
}

export const bool2String = (val: boolean | null | undefined | string): string | null => {
    if (typeof val === 'string')
        return (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') ? val : null;
    else
        return (val !== null && val !== undefined) ? (val ? 'true' : 'false') : null;
}
export const string2Bool = (val: string | null | undefined | boolean): boolean | null => {
    if (typeof val == 'boolean')
        return val;
    else {
        if (val !== null && val !== undefined) {
            if (val === 'true') return true;
            else if (val === 'false') return false;
            else return null;
        } else
            return null;
    }
}

export function preloadImage(src: string) {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = function () {
            resolve(img)
        }
        img.onerror = img.onabort = function () {
            reject(src)
        }
        img.src = src
    })
}

export function formatDt(date: FPNetDate, format: string = 'dd/LL/yyyy') {
    if (date)
        switch (typeof (date)) {
            case 'string':
                if (format) {
                    return DateTime.fromISO(date).toFormat(format);// format personalizzato
                } else {
                    return DateTime.fromISO(date).toFormat('yyyy/LL/dd');// 1999-04-11
                }
            case 'object':
                return DateTime.fromJSDate(date).toFormat(format);
            default:
                return '??/??/????'
        }
    return '';
}

export const currencyFormat = new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'});
export const HHmmFormat = new Intl.NumberFormat('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2});
export const pagaOrariaFormat = new Intl.NumberFormat('it-IT', {style: 'currency', minimumFractionDigits: 4, maximumFractionDigits: 4, currency: 'EUR'});
export const percentualFormat = new Intl.NumberFormat('it-IT', {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2});

const decimalFormat = new Intl.NumberFormat('it-IT', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2});

export const mm2HHmmFormat = function (x: number, format: Intl.NumberFormat = HHmmFormat, zeroValue: string = '??,??') {
    if (typeof x !== undefined && typeof x !== null) {
        let hh = x / 60;
        let hhmm = Math.trunc(hh);
        let cc = hh - hhmm;
        cc *= 0.6;
        hhmm += cc;
        return format.format(hhmm)
    } else {
        return zeroValue
    }
}

/*

    //funzione per formattare le quantità orarie, per 150 restituisce '2,30'
    //@param x quantità orario espressa in minuti, es. 150 = 2,5 h

function minuti2hhmm(x: number): string {
    if (x || x === 0) {
        var hh = x / 60;
        var hhmm = Math.trunc(hh);
        var cc = hh - hhmm;
        cc *= 0.6; // 0.6 => 60/100;
        hhmm += cc;
        return hhmm.toFixed(2).toString();
    } else {
        return '';
    }
}

*/


export const floatFormat = function (x: number, format: Intl.NumberFormat = decimalFormat, zeroValue: string = '??,??') {
    if (typeof x !== undefined && typeof x !== null) {
        return format.format(x)
    } else {
        return zeroValue
    }
}

export const timbratureFormat = function (timb: string | null, zeroValue: string = '--:--') {
    if (timb) {
        return DateTime.fromFormat(timb, 'HHmm').toFormat('HH:mm')
    } else {
        return zeroValue
    }
}


// Vedi anche https://lodash.com/
export const range = (start: number, end: number, step = 1) => {
    let output = [];

    if (typeof end === 'undefined') {
        end = start;
        start = 0;
    }

    for (let i = start; i < end; i += step) {
        output.push(i);
    }

    return output;
};

export const averageRGB = function (c1: string | null | undefined, c2: string | undefined) {

    // Keep helper stuff in closures
    const reSegment = /[\da-z]{2}/gi;

    // If speed matters, put these in for loop below
    function dec2hex(v: number) {
        return v.toString(16);
    }

    function hex2dec(v: string) {
        return parseInt(v, 16);
    }

    const getColor = function () {
        if (c1 && c2) {
            // Split into parts
            let b1: RegExpMatchArray | null = c1.match(reSegment);
            let b2: RegExpMatchArray | null = c2.match(reSegment);
            let t: string;
            let c: string[] = [];

            // Average each set of hex numbers going via dec
            // always rounds down
            if (b2 && b1) {
                // const b1Length = b1.length;
                for (let i = b1.length; i;) {
                    t = dec2hex((hex2dec(b1[--i]) + hex2dec(b2![i])) >> 1);
                    // Add leading zero if only one character
                    c[i] = t.length === 2 ? '' + t : '0' + t;
                }
            }

            return '#' + c.join('');
        }
    }

    return getColor();
};

export function invertColor(hex: string, bw: boolean) {
    function padZero(str: string, len: number | undefined = 2) {
        let zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);
    }

    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    let r: number | string = parseInt(hex.slice(0, 2), 16),
        g: number | string = parseInt(hex.slice(2, 4), 16),
        b: number | string = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    let r2 = (255 - r).toString(16),
        g2 = (255 - g).toString(16),
        b2 = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r2) + padZero(g2) + padZero(b2);
}

/**
 * Funzione per calcolare la differenza tra 2 date.
 *
 * Restituisce un oggetto con tre proprieta' - years, months e days
 * es. {years:0, months: 1, days: 2}
 *
 * Nel caso in cui le date non siano valorizzate, eseguo console.warn()
 * @param dtInizio
 * @param dtFine
 * @param checkDiff - a "true", restituisce TRUE se le date sono UGUALI, altrimenti FALSE
 */
export function datesDifference(dtInizio: FPNetDate, dtFine: FPNetDate, checkDiff: boolean = true) {
    if (dtInizio && dtFine && dtInizio !== '' && dtFine !== '') {
        let inizio = DateTime.fromISO(dtInizio);
        let fine = DateTime.fromISO(dtFine)

        if (!checkDiff) {
            //------- restituisco l'oggetto contenente la differenza tra le 2 date -------
            return (fine.diff(inizio, ['years', 'months', 'days'])).toObject()
        }
        if (checkDiff) {
            let diffObj = (fine.diff(inizio, ['years', 'months', 'days'])).toObject()
            //------- restituisco TRUE se le date sono UGUALI, altrimenti FALSE!!! -------
            return (diffObj && diffObj.years === 0 && diffObj.months === 0 && diffObj.days === 0)
        }
    } else {
        return console.warn('fn: datesDifference() in util.ts -> La data inizio e&bsol;o fine sono null o stringa vuota!');
    }
}

export const isDateEqual = (d1: FPNetDate, d2: FPNetDate) => {
    const a = DateTime.fromISO(d1!).startOf('day');
    const b = DateTime.fromISO(d2!).startOf('day');
    return a.equals(b);
}

// isDateBetween: https://stackoverflow.com/questions/75290921/determine-if-a-specific-datetime-is-within-a-time-interval-using-luxon
// NB: dtFine viene esclusa dall'intervallo VALIDO!
// https://github.com/moment/luxon/issues/1105 viene suggerito di aggiungere un millisecondo per includere anche l'estremo superiore!
export function isDateBetween(dtInizio: string, dtFine: string,
                              date: string,
                              includeDtFine: boolean = true
) {
    if (dtInizio && dtFine && date) {
        const inizio = DateTime.fromISO(dtInizio).startOf('day');
        const fine = DateTime.fromISO(dtFine).endOf('day');
        const dateTimeToCheck = DateTime.fromISO(date);

        const interval = Interval.fromDateTimes(inizio, includeDtFine ? fine.plus({'millisecond': 1}) : fine);

        return interval.contains(dateTimeToCheck);
    } else {
        console.warn('fn: isDateBetween() in util.ts -> Una data passata ai parametri della fn è null o stringa vuota!');
        return false;
    }
}